import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseValueAccessor } from 'src/app/core/base/base.value-accessor';
import { OdontoOralHealthModel } from 'src/app/model/odonto/oral-health';
import { OdontoOralHygieneModel } from 'src/app/model/odonto/oral-hygiene';
import { ODONTO_MODULE_CONSTANTS } from '../../odonto.constants';

@Component({
  selector: 'ms-odonto-oral-health',
  templateUrl: './odonto.oral-health.component.html',
  styleUrls: ['./odonto.oral-health.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: OdontoOralHealthComponent,
      multi: true,
    },
  ],
})
export class OdontoOralHealthComponent extends BaseValueAccessor<OdontoOralHealthModel> {
  readonly screen = ODONTO_MODULE_CONSTANTS;
  @Input() turn = -1;
  @Input() readonly = false;
  @Input() hygiene?: OdontoOralHygieneModel[] = [];
  @Output() hygieneChange = new EventEmitter<OdontoOralHygieneModel[]>();

  handleSelectPart = (item: OdontoOralHygieneModel, part?: string) => {
    if (!this.readonly) {
      switch (part) {
        case '01':
          item.partNumber01 = !item.partNumber01;
          break;
        case '02':
          item.partNumber02 = !item.partNumber02;
          break;
        case '03':
          item.partNumber03 = !item.partNumber03;
          break;
      }
      item.changed = true;
    }
  };

  addValueToPlaque = (item: OdontoOralHygieneModel) => {
    if (!this.readonly) {
      this.addValue(item, 'plaque');
      item.changed = true;
    }
  };

  addValueToCalc = (item: OdontoOralHygieneModel) => {
    if (!this.readonly) {
      this.addValue(item, 'calc');
      item.changed = true;
    }
  };

  addValueToGingivitis = (item: OdontoOralHygieneModel) => {
    if (!this.readonly) {
      switch (item.gingivitis) {
        case undefined:
          item.gingivitis = 1;
          break;
        case 1:
          item.gingivitis = undefined;
          break;
      }
      item.changed = true;
    }
  };

  get calculateCPO(): number {
    let cpoTotal = 0;
    cpoTotal += this.value.cpoC ? this.value.cpoC : 0;
    cpoTotal += this.value.cpoP ? this.value.cpoP : 0;
    cpoTotal += this.value.cpoO ? this.value.cpoO : 0;
    return cpoTotal;
  }

  get calculateCEO(): number {
    let ceoTotal = 0;
    ceoTotal += this.value.ceoC ? this.value.ceoC : 0;
    ceoTotal += this.value.ceoE ? this.value.ceoE : 0;
    ceoTotal += this.value.ceoO ? this.value.ceoO : 0;
    return ceoTotal;
  }

  get getPlaqueTotal(): number {
    return this.calculateTotal('plaque');
  }

  get getCalcTotal(): number {
    return this.calculateTotal('calc');
  }

  get getGingivitisTotal(): number {
    return this.calculateTotal('gingivitis');
  }

  private calculateTotal = (
    property: 'plaque' | 'calc' | 'gingivitis'
  ): number => {
    if (!this.hygiene) {
      return 0;
    }
    return this.hygiene
      .map((item) => item[property] || 0)
      .reduce((item, total) => item + total, 0);
  };

  private addValue = (
    item: OdontoOralHygieneModel,
    property: 'plaque' | 'calc'
  ) => {
    switch (item[property]) {
      case undefined:
        item[property] = 1;
        break;
      case 1:
        item[property] = 2;
        break;
      case 2:
        item[property] = 3;
        break;
      case 3:
        item[property] = undefined;
        break;
    }
  };
}
